import React from "react";
import { CalculatorButtons } from "../stylesCalculator";


export default function Button (props: any) {
    

    return (
        <CalculatorButtons className={`
            button
            ${props.operation ? 'operation' : ''}
            ${props.double ? 'double' : ''}
            ${props.triple ? 'triple' : ''}
        `} onClick={e => props.click && props.click(props.label)}>
            {props.label}
            </CalculatorButtons>
        
    );
}
